import ApiHelper from '@/utils/api-helper'
import API from '@/constants/api'

class BlogArticleService {
  static getBlogArticles(limit = 100, page = 1, options = {}) {
    let fetchUrl = `${
      API.URL + API.BLOG_ARTICLE
    }?pageSize=${limit}&page=${page}&populate=${!!options.populate}&overview=${!!options.overview}`

    if (options.myItems) {
      fetchUrl += `&filter=myItems`
    }

    if (options.category) {
      fetchUrl += `&category=${options.category}`
    }

    if (options.domain) {
      fetchUrl += `&domain=${options.domain}`
    }

    if (options.author) {
      fetchUrl += `&author=${options.author}`
    }

    if (options.company) {
      fetchUrl += `&company=${options.company}`
    }

    return ApiHelper.fetch(fetchUrl)
  }

  static getBlogAuthors() {
    return ApiHelper.fetch(`${API.URL + API.BLOG_ARTICLE}/authors`)
  }

  static getBlogArticle(slug) {
    return ApiHelper.fetch(`${API.URL + API.BLOG_ARTICLE}/${slug}`)
  }

  static addBlogArticle(blogArticle) {
    return ApiHelper.fetch(`${API.URL + API.BLOG_ARTICLE}`, {
      method: 'POST',
      body: JSON.stringify({
        blogArticle
      })
    })
  }

  static updateBlogArticle(blogArticle) {
    if (typeof blogArticle._id === 'undefined') {
      return this.addBlogArticle(blogArticle)
    }

    return ApiHelper.fetch(`${API.URL + API.BLOG_ARTICLE}/${blogArticle['_id']}`, {
      method: 'PUT',
      body: JSON.stringify({
        blogArticle
      })
    })
  }

  static deleteBlogArticle(id) {
    return ApiHelper.fetch(`${API.URL + API.BLOG_ARTICLE}/${id}`, {
      method: 'DELETE'
    })
  }
}

export default BlogArticleService
